import { ApiTabIndex } from '@/Enums/ReportingDashboard/ApiTabIndex.enum';
import type SocialReportType from '@/Enums/ReportingDashboard/Social/ReportType.enum';
import type { IBaseDataReport } from '@/Interfaces/ReportingDashboard/Social/Report.interface';
import type { IAbortSignalThunkArg } from '@/Interfaces/Slices/AsyncThunk.interface';
import { getEffectiveFilters } from '@/helpers/reportingDashboard/filters';
import type { RootState } from '@/store';
import {
  selectReportingDashboardCurrentApiTabClients,
  selectReportingDashboardCurrentApiTabWhitelabels,
} from '@/store/selectors/reportingDashboard/shared.selectors';
import { AsyncThunkPayloadCreator } from '@reduxjs/toolkit';
import { fetchEsmReport } from './esm';
import { getReportingFilter } from './filters';

const SOCIAL_REPORTING_URL = '/reportingDashboard/social/report';

export const socialReportRequestHandler =
  <TReport = IBaseDataReport>(
    reportType: SocialReportType,
    fallbackValues: TReport | IBaseDataReport = {
      report: [],
    },
  ): AsyncThunkPayloadCreator<TReport, IAbortSignalThunkArg> =>
  async (payload, { getState }) => {
    const state = getState() as RootState;
    const {
      me: { role },
    } = state;

    const whitelabels = selectReportingDashboardCurrentApiTabWhitelabels(state);
    const clients = selectReportingDashboardCurrentApiTabClients(state);

    const filters = getEffectiveFilters(state, ApiTabIndex.Social);

    const appliedFilter = getReportingFilter(filters, role!, clients, whitelabels);
    if (!appliedFilter.advertiserIds?.length && !appliedFilter.campaignIds?.length) {
      return { ...fallbackValues, filters } as TReport;
    }

    const reportResponseData = await fetchEsmReport({
      signal: payload?.signal,
      url: SOCIAL_REPORTING_URL,
      body: {
        reportType,
        filters: appliedFilter,
      },
    });

    return { ...(reportResponseData ?? fallbackValues), filters };
  };
